import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/shared/ui';

import styles from './InlineConfirm.module.scss';

type Props = {
  message: ReactNode;
  confirmLabel: ReactNode;
  // Offered first, before the confirmation, e.g. saving what it would drop.
  primaryAction?: ReactNode;
  // In place of "Cancel", which closes the question.
  cancelLabel?: ReactNode;
  pending?: boolean;
  disabled?: boolean;
  className?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const InlineConfirm: FC<Props> = ({
  message,
  confirmLabel,
  primaryAction,
  cancelLabel,
  pending,
  disabled,
  className,
  onConfirm,
  onCancel,
}) => (
  <div className={cn(styles.confirm, className)} role="alert">
    <p className="p3">{message}</p>
    <div className={styles.actions}>
      {primaryAction}
      <Button
        size="small"
        variant={primaryAction ? 'secondary' : 'primary'}
        disabled={pending || disabled}
        loading={pending}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
      <Button
        size="small"
        variant="tertiary"
        disabled={pending || disabled}
        onClick={onCancel}
      >
        {cancelLabel ?? (
          <FormattedMessage id="global.cancel" defaultMessage="Cancel" />
        )}
      </Button>
    </div>
  </div>
);
